import axios from 'axios';
import { attachCsrfInterceptor } from '../utils/csrf';

const baseURL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

const instance = axios.create({
  baseURL,
  withCredentials: true,
});

attachCsrfInterceptor(instance);

export default instance;
